import { UserSessionResponse } from "../app/interfaces"
export * from "./permissions"

export const getNumber = (
  value: string | number,
  defaultValue?: number,
): number => {
  if (typeof value === 'number') {
    return value
  }

  const num = parseInt(value, 10)
  if (defaultValue) {
    return isNaN(num) ? defaultValue : num
  }

  return num
}

export const currencySymbol = (cur: string): string => {
  cur = cur.toUpperCase()
  if (cur === 'USD') {
    return '$'
  } else if (cur === 'INR') {
    return '₹'
  }
  return cur
}

export const ordinal_suffix_of = (i: number): string => {
  const j: number = i % 10
  const k: number = i % 100
  if (j === 1 && k !== 11) {
    return `${String(i)}st`
  }
  if (j === 2 && k !== 12) {
    return `${String(i)}nd`
  }
  if (j === 3 && k !== 13) {
    return `${String(i)}rd`
  }
  return `${String(i)}th`
}

export const encodeHash = (input?: string | number): string | number => {
  if (!input) return "";
  if (typeof input !== 'string') return input;
  return input.replace(/#/g, '%23')
}

export const decodeHash = (input?: string | number): string | number => {
  if (!input) return "";
  if (typeof input !== 'string') return input;
  return input.replace(/%23/g, '#')
}

export const ucFirst = (name: string): string =>
  name.charAt(0).toUpperCase() + name.slice(1)